export default __webpack_public_path__ + "static/media/apartment.465528b3.png";